import React from "react";
import { Trans } from 'react-i18next';
import { Table } from "reactstrap";

const TaskChart = ({ match, t, tasks, fetchEmployees, userPermission }) => {
    const notStartedYetTasks = tasks?.filter(task => task?.progress === "Not Started")?.length;
    const inProgressTasks = tasks?.filter(task => task?.progress === "In Progress")?.length;
    const completedTasks = tasks?.filter(task => task?.progress === "Completed")?.length;
    const currentDate = new Date();

    
    const lateTasks= tasks?.filter(task => task?.end_date && new Date(task?.end_date) < currentDate);
    return (
        <Table size="lg">
            <tbody>
                    <tr>
                        <td className="text-center"><Trans>Not Started</Trans></td>
                        <td className="text-center">{notStartedYetTasks}</td>
                    </tr>
                    <tr>
                        <td className="text-center"><Trans>In Progress</Trans></td>
                        <td className="text-center">{inProgressTasks}</td>
                        
                    </tr>
                    <tr>
                        <td className="text-center"><Trans>Completed</Trans></td>
                        <td className="text-center">{completedTasks}</td>
                    </tr>
                    <tr>
                        <td className="text-center"><Trans>Late</Trans></td>
                        <td className="text-center">{lateTasks?.length} <Trans>tasks late</Trans></td>
                    </tr>
            </tbody>
        </Table>
    );
};

export default TaskChart;